/**
 * Onglets de l'ecran Admin. `reminders` (8e onglet) etait VOLONTAIREMENT absent
 * en vague 1 (STOP-11 : differe tant que le mailer ACS n'existait pas) ; AD-G
 * l'ajoute (1er consommateur de @gs/mailer, FRAG R merge). Sa cle i18n
 * `gest:admin.tabs.reminders` est indirecte (t(`...${tab}`)) -> manual-keys.ts.
 */
export const ADMIN_TAB_KEYS = [
  'overview', 'members', 'teams', 'remuneration', 'contrats', 'questions', 'reminders', 'ce', 'audit',
] as const;
export type AdminTab = (typeof ADMIN_TAB_KEYS)[number];

/** Vue d'ensemble seule en tete ; les 8 autres onglets sous 5 sections (PoC IA). */
export const ADMIN_TAB_GROUPS: ReadonlyArray<{ sectionKey: string; tabs: readonly AdminTab[] }> = [
  { sectionKey: 'people', tabs: ['members'] },
  { sectionKey: 'structure', tabs: ['teams'] },
  { sectionKey: 'remuneration', tabs: ['remuneration', 'contrats'] },
  { sectionKey: 'configuration', tabs: ['questions', 'reminders'] },
  { sectionKey: 'accessAudit', tabs: ['ce', 'audit'] },
];
